import {Grid, IconButton, PlusIcon, UnstableCard as Paper} from '@yandex-delivery/blocks'
import {memo} from 'react'

import {RemoveButton} from 'src/shared/components/desktop'

import {DestinationPoint} from './DestinationPoint/DestinationPoint'
import {useDestinationPoints} from './hooks'
import type {Props} from './types'

export const DestinationPoints = memo<Props>(function DestinationPoints(props) {
  const {name} = props
  const {destinations, addDestinationPoint, removeDestinationPoint, isAddButtonVisible} = useDestinationPoints(props)

  return (
    <>
      {destinations.map((field, index, origin) => {
        return (
          <Grid key={field.id} xs={12} item>
            <Paper radius="L">
              <DestinationPoint
                key={field.id}
                name={`${name}.${index}`}
                orderNumber={index + 1}
                RemoveButtonComponent={
                  isAddButtonVisible && (
                    <Grid justify="flex-end" size="s" container>
                      <Grid item>
                        <IconButton onPress={addDestinationPoint} variant="ghost">
                          <PlusIcon />
                        </IconButton>
                      </Grid>
                      {origin.length > 1 && (
                        <Grid item>
                          <RemoveButton
                            data-e2e={`${name}.${index}.remove-button`}
                            index={index}
                            onClick={removeDestinationPoint}
                            variant="ghost"
                          />
                        </Grid>
                      )}
                    </Grid>
                  )
                }
              />
            </Paper>
          </Grid>
        )
      })}
    </>
  )
})
